import React from 'react';

/**
 * Bloque "Código embebido" del builder. En el sitio público no pinta NADA a
 * propósito: el snippet del tenant vive en `integrations.embed_code` y lo
 * inyecta `EmbeddedCode` desde el layout, para que valga en todas las páginas
 * (un chat que solo aparece en la home no le sirve a nadie).
 *
 * Entonces, ¿para qué existe acá? Porque el nodo SÍ se guarda en
 * `elements_structure`: es donde el dealer arrastra el elemento y desde donde
 * abre su configuración en el editor. Y `sanitizeCraftState` convierte en
 * `Unknown` todo nodo cuyo `resolvedName` el render no conozca — si esto no
 * estuviera registrado, el bloque desaparecería del canvas del cliente sin
 * decir nada. Por eso el render va SIEMPRE deployado antes que el editor.
 */
export const EmbedCodeBlock = () => null;

// @ts-ignore — craft config, igual que el resto de bloques del render
(EmbedCodeBlock as any).craft = {
  displayName: 'EmbedCodeBlock',
  props: {},
  rules: {
    canDrag: () => true,
  },
};

export default EmbedCodeBlock;
